/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { FinanceDetailsDto } from '../model/financeDetailsDto';
import { FinanceServiceRequestDto } from '../model/financeServiceRequestDto';
import { FinanceServiceResponseDto } from '../model/financeServiceResponseDto';
import { SubProductChargesRequestDto } from '../model/subProductChargesRequestDto';
import { SubProductChargesResponseDto } from '../model/subProductChargesResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FinanceServiceControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getFinanceProducts
     * 
     * @param financeServiceRequest financeServiceRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFinanceProductsUsingPOST(financeServiceRequest: FinanceServiceRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<FinanceServiceResponseDto>>;
    public getFinanceProductsUsingPOST(financeServiceRequest: FinanceServiceRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FinanceServiceResponseDto>>>;
    public getFinanceProductsUsingPOST(financeServiceRequest: FinanceServiceRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FinanceServiceResponseDto>>>;
    public getFinanceProductsUsingPOST(financeServiceRequest: FinanceServiceRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (financeServiceRequest === null || financeServiceRequest === undefined) {
            throw new Error('Required parameter financeServiceRequest was null or undefined when calling getFinanceProductsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<FinanceServiceResponseDto>>(`${this.basePath}/financeService/financeproducts`,
            financeServiceRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getFinancePrograms
     * 
     * @param financeServiceRequest financeServiceRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFinanceProgramsUsingPOST(financeServiceRequest: FinanceServiceRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<FinanceServiceResponseDto>>;
    public getFinanceProgramsUsingPOST(financeServiceRequest: FinanceServiceRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FinanceServiceResponseDto>>>;
    public getFinanceProgramsUsingPOST(financeServiceRequest: FinanceServiceRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FinanceServiceResponseDto>>>;
    public getFinanceProgramsUsingPOST(financeServiceRequest: FinanceServiceRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (financeServiceRequest === null || financeServiceRequest === undefined) {
            throw new Error('Required parameter financeServiceRequest was null or undefined when calling getFinanceProgramsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<FinanceServiceResponseDto>>(`${this.basePath}/financeService/financeprograms`,
            financeServiceRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSelectedFinDetails
     * 
     * @param portfolioId portfolioId
     * @param quotationId quotationId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSelectedFinDetailsUsingGET(portfolioId: number, quotationId: string, observe?: 'body', reportProgress?: boolean): Observable<FinanceDetailsDto>;
    public getSelectedFinDetailsUsingGET(portfolioId: number, quotationId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FinanceDetailsDto>>;
    public getSelectedFinDetailsUsingGET(portfolioId: number, quotationId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FinanceDetailsDto>>;
    public getSelectedFinDetailsUsingGET(portfolioId: number, quotationId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (portfolioId === null || portfolioId === undefined) {
            throw new Error('Required parameter portfolioId was null or undefined when calling getSelectedFinDetailsUsingGET.');
        }

        if (quotationId === null || quotationId === undefined) {
            throw new Error('Required parameter quotationId was null or undefined when calling getSelectedFinDetailsUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FinanceDetailsDto>(`${this.basePath}/financeService/selectedFinDet/${encodeURIComponent(String(portfolioId))}/${encodeURIComponent(String(quotationId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSubProductCharges
     * 
     * @param subproductChargeRequest subproductChargeRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSubProductChargesUsingPOST(subproductChargeRequest: SubProductChargesRequestDto, observe?: 'body', reportProgress?: boolean): Observable<SubProductChargesResponseDto>;
    public getSubProductChargesUsingPOST(subproductChargeRequest: SubProductChargesRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubProductChargesResponseDto>>;
    public getSubProductChargesUsingPOST(subproductChargeRequest: SubProductChargesRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubProductChargesResponseDto>>;
    public getSubProductChargesUsingPOST(subproductChargeRequest: SubProductChargesRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (subproductChargeRequest === null || subproductChargeRequest === undefined) {
            throw new Error('Required parameter subproductChargeRequest was null or undefined when calling getSubProductChargesUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SubProductChargesResponseDto>(`${this.basePath}/financeService/subproductcharges`,
            subproductChargeRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
